import React from "react";
import { Button, Modal, Spinner } from "react-bootstrap";

const DeleteCameraModal = (props: any) => {
    return (
        <Modal show={true}
               onHide={props.onHide}
               dialogClassName="modal-dialog-centered">
            <Modal.Header
                onHide={props.onHide} closeButton>
                <h4 className="modal-title">
                    Delete {" "}
                    <span
                        className="text-danger">
                        {props.cameraToDelete.name}
                    </span> ?
                </h4>
            </Modal.Header>
            <Modal.Body>
                <p>Are you sure you want to delete this camera?</p>
            </Modal.Body>
            <Modal.Footer>
                {props.isSaving && <Spinner className="m-2"/>}
                <Button
                    disabled={props.isSaving}
                    onClick={() => props.onHide()} variant="secondary">
                    Cancel
                </Button>
                <Button
                    disabled={props.isSaving}
                    onClick={props.onDelete} variant="danger">
                    Delete
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DeleteCameraModal;